import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { PatientAssessmentControllerXApi } from "../../../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  getPageSize,
  useBaseContent,
} from "../../../../utils/utils";
import { useRef } from "react";

interface Props {
  patientId?: string;
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  scheduled?: boolean;
  archive?: boolean;
  sendDate?: string;
  submittedDate?: string;
  xTENANTID?: string;
  searchString?: string;
  screenerType?: string;
  sendBy?: string;
  sortDirection?: string;
}

export type OptionData = {
  name: string;
  uuid: string;
};

/**
 *
 * @author Rajkumar Rathod
 */
export const useGetAllPatientAssessment = (
  props: Props
): useBaseContent<OptionData> => {
  const {
    xTENANTID,
    pagination,
    patientId,
    gridSorting,
    scheduled,
    archive,
    sendDate,
    submittedDate,
    searchString,
    screenerType,
    sendBy,
    sortDirection = "asc",
  } = props;

  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: searchString,
    prevPage,
  });
  const pageSize = getPageSize(searchString, pagination);

  return useQuery({
    queryKey: [
      "patient-chart-assessment-list",
      // pagination.page,
      pageSize,
      pageIndex,
      patientId,
      // pagination,
      gridSorting,
      scheduled,
      archive,
      sendDate,
      submittedDate,
      searchString,
      screenerType,
      sendBy,
      sortDirection,
      xTENANTID,
    ],
    placeholderData: keepPreviousData,
    queryFn: async () =>
      await new PatientAssessmentControllerXApi(
        getConfigObject()
      ).getAllPatientAssessments1(
        patientId, //patientId
        // pagination.page, //page
        // pagination.pageSize, //size
        pageIndex, //page
        pageSize, //size
        undefined, //sortBy
        sortDirection, //sortDirection
        scheduled, //scheduled
        archive, //archive
        sendDate ?? undefined, //sendDate
        submittedDate ?? undefined, //submittedDate
        searchString ?? undefined, //searchString
        screenerType ?? undefined, //screenerType
        sendBy ?? undefined, //sendBy
        xTENANTID
      ),
  });
};
